import { jwtDecode } from "jwt-decode";

export const getUserType = () => localStorage.getItem("lizera_userType");

export const getToken = () => localStorage.getItem("lizera_token");

export const getRefreshToken = () => localStorage.getItem("lizera_refreshToken");

export const getUserName = () => localStorage.getItem("lizera_userName");

export const getUserId = () => localStorage.getItem("lizera_userId");

export const getParamType = () => localStorage.getItem("lizera_paramType");

export const getTimeZone = () => localStorage.getItem("lizera_timezoneId");

export const getdebuglogsfilter = () => localStorage.getItem("lizera_debugLogFilter");

export const getTenantIdFromLocalStorage = () =>{
  let tenantId = localStorage.getItem("lizera_access_tenant_id");
  return tenantId ? Number(tenantId) : -1;
}

export const getTokenFromLocalStorage = () => {
  let token = localStorage.getItem("lizera_token");
  return token ? token : "";
};

export const getRoleNameFromLocalStorage = () => {
  let roleName = localStorage.getItem("lizera_role_name");
  return roleName ? roleName : "";
};

export const getTenantIdFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let tenantId:any = 0;
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    tenantId = userToken.tenantId;
  }
  return parseInt(tenantId);
}

export const getOrgIdFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let orgId:any = "";
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    orgId = userToken.organizationId;
  }
  return orgId;
}

export const getUserIdFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let userId:any = 0;
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    userId = userToken.userId;
  }
  return parseInt(userId);
}

export const getcustIdFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let userId:any = 0;
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    userId = userToken.customerId;
  }
  return parseInt(userId);
}

export const getUserEmailFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let userEmail:string = "";
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    userEmail = userToken.userEmail;
  }
  return userEmail;
}

export const getCustomerNameFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let customerName:string = "";
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    customerName = userToken.customerName;
  }
  return customerName;
}

export const getCustomerEmailFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let userEmail:string = "";
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    userEmail = userToken.customerEmail;
  }
  return userEmail;
}

export const getCustomerStoreIdFromToken = () => {
  let token = localStorage.getItem("lizera_token");
  let storeId:any = 0;
  if (token !== null && token !== "") {
    const userToken: any = jwtDecode(token);
    storeId = userToken.storeId;
  }
  return storeId;
}

export const getTenantAccessFromLocalStorage = () :any => {
  let tenantId = localStorage.getItem("lizera_access_tenant_id");
   return tenantId ? parseInt(tenantId) : -1;
}

export const getIsTenantAccessFromLocalStorage = () :any => {
  let isTenantAccess = localStorage.getItem("lizera_is_access_tenant");
   return isTenantAccess ? JSON.parse(isTenantAccess) : false;
}

export const getUserTypeFromLocalStorage = () => {
  let userType = localStorage.getItem('lizera_userType');
  return userType ? userType : "";
}

export const getBusinessTypeIdFromLocalStorage = () => {
  let businessTypeId = localStorage.getItem('lizera_businessTypeId');
  return (businessTypeId !== null && businessTypeId !== undefined && businessTypeId !== "") ? parseInt(businessTypeId) : -1;
}
export const getStoreIdFromLocalStorage = () => {
  let id = localStorage.getItem('lizera_store_id');
  return (id !== null && id !== undefined && id !== "") ? parseInt(id) : -1;
}
export const getStoreCodeFromLocalStorage = () => {
  let storeCode = localStorage.getItem('lizera_store_code');
  return storeCode ? storeCode : "";
}
export const getHeadquarterIdFromLocalStorage = () => {
  let id = localStorage.getItem('lizera_headquarter_id');
  return (id !== null && id !== undefined && id !== "") ? parseInt(id) : -1;
}

export const getAccessOrgIdFromLocalStorage = () => {
  let orgId = localStorage.getItem('lizera_access_org_id');
  return orgId ? orgId : "";
}

export const getCurrentLanguageFromLocalStorage = () => {
  let lang = localStorage.getItem("lizera_language");
  return lang === 'en' ? 'en' : 'jp'
}

export const getLanguageFromLocalStorage = () => {
  let language = localStorage.getItem('lizera_language');
  return language ? language : 'jp';
}

export const getCurrentSidebarExpansionFromLocalStorage = () => {
  return localStorage.getItem("lizera_sidebarClosed") === 'true';
}

export const getThemeFromLocalStorage = () => {
  let theme = localStorage.getItem('lizera_theme');
  return theme ? theme : '0';
}

export const getBlockedStoreIdsCustomerFromLocalStorage = () => {
  let ids  = localStorage.getItem('lizera_blocked_stores');
  return ids ? JSON.parse(ids) : [];
}